module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/lpo_mv_bg-020928fc3307691584327812f0fc78d7.png";